<template>
  <div class="virtual-category-render">
    <Content
      class="virtual-category__view-default"
      :items="itemsComp"
      :promise="promise"
      @input="updateView"
      :value="selected"
      @create="create"
    ></Content>
    <Portal v-if="view === 'modal'">
      <ModalComponent :show="true" v-on="$listeners" class="virtual-category-render__modal" :clickaway="true">
        <Card theme="border">
          <template #default>
            <InputComponent class="virtual-category-render__search">
              <input
                v-model="filter.search"
                type="text"
                :placeholder="$t('search') + '...'"
                class="elder-input__element"
              />
              <div class="elder-input__icon">
                <FontAwesomeIcon :icon="['fal', 'search']" />
              </div>
            </InputComponent>
            <Content
              :items="itemsComp"
              :promise="promise"
              @input="$ev => (selected = $ev)"
              :value="selected"
              @create="create"
            ></Content>
          </template>
          <template #footer>
            <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="$emit('close')" />
            <ButtonComponent :label="$t('confirm')" :icon="['fal', 'angle-right']" theme="primary" @click="submit" />
          </template>
        </Card>
      </ModalComponent>
    </Portal>
  </div>
</template>

<script>
import fetch from '@/fetch'
import { Debounce } from '@/utils'
import { ConvertStringToTree } from './utils'

import Card from '@/components/Card'
import { ModalComponent } from 'vue-elder-modal'
import { InputComponent } from 'vue-elder-input'
import Tree from './Tree'
import CategoryInput from './Input'
import Create from './Create'
import Content from './Content'

import Portal from '@/components/Portal'

export default {
  props: {
    value: String,
    items: [String, Array, Function],
    view: {
      type: String,
      enums: ['modal', 'default'],
      default: 'modal',
    },
    disableSort: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      filter: () => this.filter,
      createdItems: () => this.createdItems,
      fetchedItems: () => this.fetchedItems,
    }
  },
  watch: {
    'filter.search': {
      handler: 'fetch',
      immediate: true,
    },
    value: {
      handler(val) {
        if (!val) return

        this.selected = val
      },
      immediate: true,
    },
  },
  data() {
    return {
      createdItems: [],
      fetchedItems: [],
      promise: null,
      filter: {
        search: null,
      },
      selected: null,
    }
  },
  computed: {
    itemsComp() {
      let set = new Set()
      if (this.value && !this.filter.search && !this.disableSort) set.add(this.value)
      let addToSet = e => set.add(e)

      this.createdItems.forEach(addToSet)

      if (this.items instanceof Array) this.items.forEach(addToSet)
      else this.fetchedItems.forEach(addToSet)

      let result = Array.from(set)

      if (!this.disableSort) result = result.sort()
      return ConvertStringToTree(result)
    },
  },
  methods: {
    fetch: Debounce(function () {
      let params = new URLSearchParams()
      if (this.filter.search) params.append('search', this.filter.search)

      let qs = params.toString()

      const set = items => {
        this.fetchedItems = items
        this.createdItems = []
      }

      switch (typeof this.items) {
        case 'string':
          return fetch(this.items + '?' + qs)
            .then(res => res.json())
            .then(items => set(items))
        case 'object':
          return
        case 'function':
          return this.items(this.filter.search).then(items => set(items))
      }
    }, 300),

    updateView(value) {
      this.selected = value
      this.$emit('input', this.selected)
    },
    submit() {
      this.$emit('input', this.selected)
      this.$emit('close')
    },
    create(value) {
      if (!value) return
      this.createdItems.push(value)
      this.selected = value
    },
  },
  components: {
    ModalComponent,
    InputComponent,
    Card,
    Tree,
    CategoryInput,
    Create,
    Portal,
    Content,
  },
}
</script>

<style lang="scss">
.virtual-category-render {
  &__modal {
    align-items: flex-start;

    .card {
      width: 100%;
      max-width: 650px;

      &__footer {
        display: flex;
        justify-content: flex-end;
        &-content {
          display: flex;
          & > :first-child {
            margin-right: 0.5rem;
          }
        }
      }
    }
  }

  &__search {
    margin-bottom: 1rem;

    .elder-input__icon {
      padding-right: 1.1em;
    }
  }
}
</style>
